/* eslint-disable */
import React from "react"
import {
  Row,
  Col,
  Input,
  Pagination,
  Spin
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import AddDrawer from '../addDrawer';
import OnTraccrButton from '../buttons/OnTraccrButton';
import MoreButton from '../buttons/MoreButton';

import CardGridItem from './CardGridItem';
import CardGridAddPopover from './CardGridAddPopover';
import SearchNotFound from './SearchNotFound';

import OnTraccrEmpty from '../OnTraccrEmpty';
import ListView from "../listview";
import { search } from '../../helpers/helpers';

import CardGridButton from './CardGridButton';
import CardGridFilterButton from './CardGridFilterButton';
import CardGridListViewSwitch from "./CardGridListViewSwitch";
import CardGridFilterDrawerButton from "./CardGridFilterDrawerButton";
import BulkSelectionHeader from './BulkSelectionHeader';
import BulkActionPasswordModal from '../modals/BulkActionPasswordModal';
import { resolveBulkWarning } from './bulkWarningDefaults';

const last = function last(array) {
  return array[array.length -1];
};

const splitArray = function splitArray(array,size) {
  let i = 0;
  const res = [];
  if(size === 0) return res;
  while ( i < array.length) {
    res.push(array.slice(i,Math.min(i+size,array.length)));
    i += size;
  }
  return res;
};

export default class CardGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer:false,
      showEditDrawer:false,
      dataSource:props.dataSource,
      currentPage:0,
      numCols:3,
      numRows:2,
      selectedRecords: [],
      bulkModal: null,
    };

    this.searching = null;
    this.currentPage = 0;
    const { pageSize = 16 } = props;
    this.pageSize = pageSize;
    this.dataSource = [];
    this.lastActivePage = [];

    this.onEditClose = this.editClosed.bind(this);
    this.onResize = this.getDimensions.bind(this);
    this.onDrawerClose = this.closeDrawer.bind(this);

    this.lastPagination = 0;
  }

  displayItem(item) {
    const {
      showEditDrawer,
    } = this.state;
    if (showEditDrawer) return;
    this.props.onItemOpened?.(item);
    this.setState({
      editProps:{ editing:false,...item,key:item.id },
      showEditDrawer:true,
      newAdd:Math.floor(new Date()),
    })
  }

  async closeDrawer(values) {
    const {
      setDisableNext,
      setDisableNextClosePO,
    } = this.props;
    if (setDisableNext) setDisableNext({});
    if (setDisableNextClosePO) setDisableNextClosePO({});
    if(!values || (this.props.add && await this.props.add.onClose(values))) {
      this.setState({
        showDrawer:false,
      });
    }
  }

  editClosed(id,values) {
    if(this.props.edit) return this.props.edit.onClose(id,values);
    return false;
  }

  onSearch(e) {
    const val = e.target.value;
    this.searchFilter(val);
  }

  searchFilter(val) {
    const {
      search:searchProps = {},
    } = this.props;
    if(val) {
      this.searching = val;
      const relevant = search({
        data: this.props.dataSource,
        value: val,
        getField: searchProps.getField ? searchProps.getField : (item) => item.name,
        customSearchRanking: searchProps.customRanking,
        searchTieBreaker: searchProps.tieBreaker
      });

      this.setPages(relevant);
      this.setState({
        dataSource:relevant,
        currentPage:0,
      });
      this.currentPage = 0;
      this.setCurrentPage();
    } else {
      this.setPages();
      this.setCurrentPage();
      this.searching = null;
      this.setState({
        dataSource:this.props.dataSource,
      });
    }
  }

  setPages(source = this.props.dataSource,pageSize = this.getPageSize()) {
    const {
      scrollable = false,
    } = this.props;
    this.dataPages = scrollable ? [source] : splitArray(source,pageSize);
    if(this.targetItem && this.dataPages.length > 0) {
      this.scrollToItem(this.targetItem);
    }
  }

  getUpdatedActivePageIndex() {
    const prevData = this.dataSource;
    const newData = this.props.dataSource;
    if(prevData.length >= newData.length) return null;

    const prevDataIds = new Set(prevData.map(data => data.id));
    const newDataFiltered = newData.filter(data => !prevDataIds.has(data.id));
    if (newDataFiltered === 0) return this.currentPage;
    const newItem = newDataFiltered[0];
    const newPage = this.dataPages.findIndex((page) => {
      return page.some((item) => item.id === newItem.id);
    });

    return newPage || null;
  }

  componentDidUpdate(prevProps) {
    if(!this.searching) {
      this.setPages();
    } else if(this.targetItem && this.dataPages.length > 0) {
      this.scrollToItem(this.targetItem);
    }
    if(this.props.dataSource !== this.dataSource && !(this.props.dataSource.length === 0 && this.dataSource.length === 0)) {
      const newPage = this.getUpdatedActivePageIndex();
      this.setState({
        dataSource:this.props.dataSource
      });
      this.dataSource = this.props.dataSource;
      if(this.dataPages.length > 0) {
        this.currentPage = Math.min(newPage || this.currentPage,this.dataPages.length - 1);

        this.setState({
          activePage:this.dataPages[this.currentPage],
        });
      } else {
        this.setState({
          activePage: [],
        });
      }
      this.searchFilter(this.searching);
      this.removeStaleSelection(this.props.dataSource);
    } else {
      this.removeStaleSelection(this.state.dataSource);
    }
    if (prevProps.isListView && !this.props.isListView) {
      this.clearSelection();
    }
  }


  componentDidMount() {
    if(this.props.onRef) {
      this.props.onRef(this);
    }
    this.setPages();
    if(this.dataPages.length > 0) {
      this.setState({
        activePage:this.dataPages[0],
      });
    }
    window.addEventListener('resize', this.onResize);
    this.getDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize',this.onResize);
    if (this.props.onRef) {
      this.props.onRef(null);
    }
  }

  getPageSize() {
    return this.state.numCols * this.state.numRows;
  }

  scrollToItem(item) {
    let targetPage = this.dataPages.findIndex((page) => (
      page.find((pageItem) => pageItem.id === item.id)
    ));

    if(targetPage < 0 || this.currentPage === targetPage) return;
    this.currentPage = targetPage;
    this.setCurrentPage();
    this.targetItem = null;
  }

  setCurrentPage() {
    this.setState({
      activePage:this.dataPages[this.currentPage],
      currentPage:this.currentPage,
    });
  }

  onPageChange(page) {
    const now = Math.floor(new Date());
    if(now - this.lastPagination < 500) return;
    this.lastPagination = now;
    this.currentPage = page - 1;
    this.setCurrentPage();
  }

  getDimensions() {
    if(!this.container) return;
    const {
      clientHeight:containerHeight,
      clientWidth:containerWidth,
    } = this.container;

    const {
      itemDimensions:{
        width:itemWidth = 285,
        height:itemHeight=  205,
      } = {},
    } = this.props;

    const hGutter = 8;
    const vGutter = 16;


    const numCols = parseInt(Math.floor((containerWidth + hGutter) / (itemWidth + hGutter)));
    const numRows = parseInt(Math.floor((containerHeight + vGutter)/(itemHeight + vGutter)));

    /*
      If the download bar is shown in chrome
      containerHeight and containerWidth will be zero
      No idea why.
    */
    if (numCols === 0 || numRows === 0) return;

    if(numCols !== this.state.numCols || numRows !== this.state.numRows) {
      this.setState({
        numCols,
        numRows,
      });
      this.setPages(this.state.dataSource,numCols * numRows);
      this.setCurrentPage();
    }
  }

  handleClick = (props) => {
    this.props.onItemOpened?.(props);
    this.setState({
      editProps: { editing: false, ...props, key: props.id },
      showEditDrawer: true,
      newAdd: Math.floor(new Date()),
    });
  };

  handleAddNewClick = () => {
    const { add = {} } = this.props;
    const { disabled = false } = add || {};

    if (disabled) return;

    this.setState({
      showDrawer: true,
      newAdd: Math.floor(new Date()),
    });
  }

  handleClearSearch = () => {
    this.searchFilter('');
  }

  clearSelection = () => {
    this.setState({ selectedRecords: [] });
  }

  // Drop removed rows and refresh snapshots (e.g. active) from the current data source
  removeStaleSelection = (dataSource = this.state.dataSource) => {
    const { selectedRecords = [] } = this.state;
    if (!selectedRecords.length) return;
    const dataById = (dataSource || []).reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    let changed = false;
    const nextSelected = [];
    selectedRecords.forEach((record) => {
      const current = dataById[record.id];
      if (!current) {
        changed = true;
        return;
      }
      if (current !== record) {
        changed = true;
      }
      nextSelected.push(current);
    });
    if (changed) {
      this.setState({ selectedRecords: nextSelected });
    }
  }

  onSelectRow = (record, checked) => {
    const { selectedRecords = [] } = this.state;
    if (checked) {
      this.setState({ selectedRecords: selectedRecords.concat([record]) });
      return;
    }
    this.setState({
      selectedRecords: selectedRecords.filter((item) => item.id !== record.id),
    });
  }

  onSelectAllRows = (checked) => {
    const { dataSource = [] } = this.state;
    this.setState({ selectedRecords: checked ? dataSource.slice() : [] });
  }

  getEligibleRecords = (action) => {
    const { selectedRecords = [] } = this.state;
    const {
      bulkActions: {
        deleteAllSelected = false,
      } = {},
    } = this.props;

    if (action === 'archive') {
      return selectedRecords.filter((record) => record.active);
    }
    if (action === 'activate') {
      return selectedRecords.filter((record) => !record.active);
    }
    if (deleteAllSelected) {
      return selectedRecords.slice();
    }
    return selectedRecords.filter((record) => !record.active);
  }

  openBulkModal = (action) => {
    const eligible = this.getEligibleRecords(action);
    if (!eligible.length) return;
    const { selectedRecords = [] } = this.state;
    this.setState({
      bulkModal: {
        action,
        eligible,
        skippedCount: selectedRecords.length - eligible.length,
      },
    });
  }

  closeBulkModal = () => {
    this.setState({ bulkModal: null });
  }

  onBulkConfirm = async ({ password }) => {
    const { bulkModal } = this.state;
    if (!bulkModal) return false;
    const { action, eligible } = bulkModal;
    const ids = eligible.map((record) => record.id);
    const {
      onBulkArchive,
      onBulkActivate,
      onBulkDelete,
    } = this.props;

    let result;
    if (action === 'archive' && onBulkArchive) {
      result = await onBulkArchive(ids, { password });
    } else if (action === 'activate' && onBulkActivate) {
      result = await onBulkActivate(ids, { password });
    } else if (action === 'delete' && onBulkDelete) {
      result = await onBulkDelete(ids, { password });
    }

    if (result) {
      this.clearSelection();
    }
    return !!result;
  }

  getContent() {
    const MyItems = this.props.itemView;
    const {
      itemDimensions,
      scrollable,
      itemProps = {},
      isLoading,
      loadingIds,
    } = this.props;
    const {
      numCols:colCount,
      numRows,
      activePage = [],
    } = this.state;

    if(
      activePage === this.lastActivePage
      && !scrollable
      && this.lastLoadingIds === loadingIds
    ) return this.cachedContent;
    this.lastActivePage = activePage;

    const spinner = <Spin
      size="medium"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 'auto',
        marginBottom: 'auto',
        width: '100px',
        height: '100px',
      }}
    />

    const empty = (
      <OnTraccrEmpty
        title={this.props.title}
        onAddNewClick={this.handleAddNewClick}
      />
    );

    const searchNotFound = (
      <SearchNotFound
        searchTerm={this.searching}
        onClearSearch={this.handleClearSearch}
        onAddNew={this.handleAddNewClick}
        title={this.props.title}
        addDisabled={this.props.add?.disabled || false}
      />
    );

    let myContent;
    if (isLoading) {
      myContent = spinner;
    } else if (this.searching && activePage.length === 0) {
      myContent = searchNotFound;
    } else {
      myContent = empty;
    }

    if(activePage && activePage.length > 0) {
      const {
        clientHeight:containerHeight,
      } = this.container;

      const {
        height:itemHeight =  205,
      } = itemDimensions;

      let myCols = [[],];

      activePage.forEach((data,idx) => {
        const lastItem = last(myCols);
        // Inject dataSource item values and dimensions as props.
        const cardItemProps = {
          ...itemProps,
          ...data,
          ...{
            style:{
              ...itemDimensions,
            }
          }
        };
        lastItem.push(
          <Col key={idx.toString()}>
            <CardGridItem>
              <MyItems {...cardItemProps}
                key={cardItemProps.id}
                onClick={this.handleClick}
                idx={idx}
                onArchive={this.props.onArchive}
                onDelete={this.props.onDelete}
                onEdit={(props) => {
                  this.setState({
                    editProps:{ editing:true,...props,key:props.id },
                    showEditDrawer:true,
                    newAdd:Math.floor(new Date()),
                  });
                }}
                loadingIds={loadingIds}
              />
              </CardGridItem>
          </Col>
        );
        if (lastItem.length === colCount && idx !== activePage.length - 1) {
          myCols.push([]);
        }
      });
      const lastItem = last(myCols);
      while (lastItem.length !== 0 && lastItem.length < colCount) {
        lastItem.push(<div style={{...itemDimensions}} key={`dummyItem-${lastItem.length}`}/>)
      }


      const margin = (
        containerHeight
        ? (containerHeight - (numRows * itemHeight))/(numRows + 1)
        : 20
      );
      myContent = [];
      myCols.forEach((cols,idx, arr) => {
        myContent.push(
          <Row
            key={idx.toString()}
            type='flex'
            justify='space-around'
            style={{
              width:'100%',
              height:itemHeight,
              marginTop:idx === 0 ? margin : margin/2,
              marginBottom: idx === arr.length - 1 ? margin : margin/2,
            }}>
              {cols}
          </Row>
        );
      });
    }
    this.cachedContent = myContent;
    this.lastLoadingIds = loadingIds;
    return myContent;
  }

  render() {
    const {
      more,
      sort = {},
      showMoreBadge,
      filter,
      filterActive,
      add = {},
      edit = {},
      scrollable,
      extra,
      onToggleListViewSwitch = false,
      isListView,
      onViewTypeChanged,
      displayColumns,
      loadingIds,
      onFilterOpen,
      disableNext,
      disableNextClosePO,
      setDisableNext,
      setDisableNextClosePO,
      fileSelected,
      entity,
      clickProps,
      testId,
      bulkActions = null,
      onBulkArchive,
      onBulkActivate,
      onBulkDelete,
    } = this.props;

    const {
      sortOptions = [],
      sortActive,
    } = sort;

    const {
      selectedRecords = [],
      bulkModal,
    } = this.state;

    const {
      canArchive: canBulkArchive = false,
      canActivate: canBulkActivate = false,
      canDelete: canBulkDelete = false,
      deleteAllSelected = false,
      entityLabel = 'items',
      warnings = {},
    } = bulkActions || {};

    const enableBulkSelect = !!(
      isListView
      && bulkActions
      && (canBulkArchive || canBulkActivate || canBulkDelete)
      && (onBulkArchive || onBulkActivate || onBulkDelete)
    );
    const hasBulkSelection = enableBulkSelect && selectedRecords.length > 0;

    const  {
      numberOfSteps = 1,
      disabled = false,
      disabledPopoverContent,
      disabledPopoverTitle,
    } = add || {};

    const {
      canEdit = () => true,
      canArchive = () => true,
      canDelete = () => true,
      numberOfSteps:editSteps = 1,
      getTitle: getEditTitle,
    } = edit;

    let myAdd = '';
    let entityName = 'Add';
    if (entity) {
      entityName += ` ${entity}`;
    }

    if (add) {
      myAdd = (
        <CardGridAddPopover
          disabled={disabled}
          title={disabledPopoverTitle}
          content={disabledPopoverContent}
        >
          <OnTraccrButton
            title={entityName}
            icon={<PlusOutlined/>}
            onClick={this.handleAddNewClick}
            iconLeft
            testId={add?.testId}
          />
        </CardGridAddPopover>
      );
    }

    const {
      editProps = {},
      activePage = [],
    } = this.state;
    const isEdit = editProps.editing;

    let editTitle  = isEdit ? this.props.edit.title : this.props.edit.title.replace('Edit ','');
    if (getEditTitle) editTitle = getEditTitle(editProps);

    const bulkWarning = bulkModal ? resolveBulkWarning({
      action: bulkModal.action,
      entityLabel,
      deleteAllSelected,
      warnings,
    }) : {};
    const listRowSelection = enableBulkSelect ? {
      selectedRowKeys: selectedRecords.map((record) => record.id),
      onSelect: this.onSelectRow,
      onSelectAll: this.onSelectAllRows,
    } : null;

    return (
      <div
        style={{height: '100%',width:'100%' }}
      >
        {hasBulkSelection ? (
          <BulkSelectionHeader
            selected={selectedRecords}
            canArchive={canBulkArchive && !!onBulkArchive}
            canActivate={canBulkActivate && !!onBulkActivate}
            canDelete={canBulkDelete && !!onBulkDelete}
            deleteAllSelected={deleteAllSelected}
            onArchive={() => this.openBulkModal('archive')}
            onActivate={() => this.openBulkModal('activate')}
            onDelete={() => this.openBulkModal('delete')}
          />
        ) : (
          <Row className="card-grid-header" type="flex" justify="start" gutter={14} style={{height:32,marginBottom:10}}>
            <Col span={add ? 5 : 7}>
              <Input.Search
                className='searchbar'
                placeholder="Search"
                value={this.searching}
                onChange={this.onSearch.bind(this)}
                allowClear
                data-testid={testId}
              />
            </Col>
            <Col>
              <CardGridFilterButton
                filter={filter}
                filterActive={!filterActive} // Not sure why this is inverted
              />
              <CardGridFilterDrawerButton
                filterActive={filterActive}
                onFilterOpen={onFilterOpen}
              />
            </Col>
            {sortOptions.length > 0 && !this.searching && (
              <Col style={{ padding: '0px 7px 0px 0px' }}>
                <CardGridButton
                  sortOptions={sortOptions}
                  sortActive={sortActive}
                />
              </Col>
            )}
            {onToggleListViewSwitch && (
              <Col style={{ padding: 0, display: 'flex' }}>
                <CardGridListViewSwitch
                  isListView={isListView}
                  onViewTypeChanged={onViewTypeChanged}
                />
              </Col>
            )}

            <Col flex='auto' style={{ padding: 0 }}>
              <Row align='middle' justify="end" style={{ width:'100%'}} gutter={12}>
                <Col>
                  {!scrollable && !isListView && <Pagination
                    showSizeChanger={false}
                    defaultCurrent={1}
                    current={this.state.currentPage + 1}
                    total={this.state.dataSource.length}
                    pageSize={this.getPageSize()}
                    hideOnSinglePage
                    onChange={this.onPageChange.bind(this)}
                    showLessItems={true}
                  />}
                </Col>
                {
                  extra &&
                  <Col style={{ marginRight: 15, padding: 0, display: 'flex', gap: 10 }}>
                    {extra}
                  </Col>
                }
                <Col flex={add ? '80px' : '0px'} style={{ padding: 0 }}>
                  {myAdd}
                </Col>
                <Col>
                  {more && (
                    <MoreButton
                      options={more}
                      showMoreBadge={showMoreBadge}
                    />
                  )}
                </Col>
              </Row>

            </Col>
          </Row>
        )}
        <div
          id='cardGridContainer'
          ref={(ref) => this.container = ref}
          style={{
            height:'calc(100% - 32px)',
          }}
        >
          {
            isListView
            ? (
              <ListView
                dataSource={this.state.dataSource}
                onClick={this.handleClick}
                columns={displayColumns}
                loadingIds={loadingIds}
                clickProps={clickProps}
                rowSelection={listRowSelection}
              />
            ) : (
              <Row style={{
                width:'100%',
                height:'100%',
              }} justify='center' align={activePage.length > 0 ? 'top' : 'middle'}>
                <Col style={{
                width:'100%',
                height:'100%',
                overflowY:scrollable ? 'scroll' : 'hidden',
              }}>
                  {this.getContent()}
                </Col>
              </Row>
            )
          }

        </div>
        {add && <AddDrawer
          onClose={this.onDrawerClose}
          isAdd
          visible={this.state.showDrawer}
          title={this.props.add.title}
          formView={this.props.add.formView}
          width={this.props.add.width}
          className={this.props.add.className}
          numberOfSteps={numberOfSteps}
          key={this.state.newAdd} // Fresh component every time
          push={this.props.add.push}
          customValidator={this.props.add.customValidator}
          disableNext={disableNext}
          disableNextClosePO={disableNextClosePO}
          disableKeyboard={fileSelected}
          validateSteps={this.props.add.validateSteps}
        />}

        {!this.props.edit ? null :
        <AddDrawer // Editing
          push={this.props.edit.push}
          customValidator={this.props.edit.customValidator}
          zIndex={this.props.edit.zIndex}
          onClose={async (values) => {
            if (setDisableNext) setDisableNext({});
            if (setDisableNextClosePO) setDisableNextClosePO({});
            const {
              editProps = {}
            } = this.state;
            if (!values) {
              this.setState({
                showEditDrawer:false,
              });
              return;
            }
            const editedData = {};
            // Only return changed fields
            Object.keys(values).forEach((key) => {
              if(editProps[key] !== values[key]) {
                editedData[key] = values[key];
              }
            });
            // Complex add/edit forms have data outside of the form 'values'
            // passed in here. So data may change out of band, and the parent component
            // may want to overrade the no data check.
            const {
              alwaysReturn,
            } = this.props.edit;
            const hasNoData = Object.keys(editedData).length === 0;
            if ((hasNoData && !alwaysReturn) || await this.onEditClose(editProps.id,editedData)) {
              this.setState({
                showEditDrawer:false,
              });
            }
          }}
          onEditStarted={canEdit(editProps) ? () => {
            this.setState({
              editProps:{...this.state.editProps,editing:true },
            });
          } : null}
          onEditCanceled={() => {
            this.setState({
              editProps:{...this.state.editProps,editing:false },
            })
          }}
          onArchive={canArchive(editProps) ? this.props.onArchive : null}
          onDelete={canDelete(editProps) ? this.props.onDelete : null}
          visible={this.state.showEditDrawer}
          title={editTitle}
          formView={this.props.edit.formView}
          formProps={this.state.editProps} // data
          width={this.props.edit.width}
          className={this.props.edit.className}
          numberOfSteps={editSteps}
          key={`edit - ${this.state.newAdd}`} // Fresh component every time
          disableNext={disableNext}
          disableNextClosePO={disableNextClosePO}
          validateSteps={this.props.edit.validateSteps}
          disableKeyboard={fileSelected}
        />}
        {bulkModal && (
          <BulkActionPasswordModal
            visible={!!bulkModal}
            onClose={this.closeBulkModal}
            onConfirm={this.onBulkConfirm}
            action={bulkModal.action}
            eligibleCount={bulkModal.eligible.length}
            skippedCount={bulkModal.skippedCount}
            entityLabel={entityLabel}
            warningHeader={bulkWarning.header}
            warningSubtext={bulkWarning.subtext}
          />
        )}
      </div>
    );
  }
}
